// Branding config — single source of truth for the tenant brand block
// shown in the sidebar (and anywhere else the brand surfaces).
//
// BRAND_NAME / BRAND_CODE / BRAND_LOGO_SRC are tenant-configurable via
// Vite env vars at build time:
//
//   VITE_BRAND_NAME="Oman Investment Authority" \
//   VITE_BRAND_LOGO_SRC="/brand/oia-logo.png" \
//   docker compose build frontend
//
// When VITE_BRAND_LOGO_SRC is set, the sidebar renders an <img>;
// otherwise it falls back to the text-tile logo using BRAND_CODE.
//
// PRODUCT_SUBLABEL is intentionally NOT tenant-configurable — it names
// the product itself ("Audit AI"), which stays constant across tenants.

export const BRAND_NAME: string =
  import.meta.env.VITE_BRAND_NAME || 'TSG OIA';

// Short token used in benchmark codes (e.g. "XYZ-INF-RE-2024") AND as
// the text inside the fallback logo tile. Defaults to the first
// whitespace-separated word of BRAND_NAME uppercased.
export const BRAND_CODE: string =
  import.meta.env.VITE_BRAND_CODE
  || BRAND_NAME.trim().split(/\s+/)[0].toUpperCase();

// Product name — shown as the small line under BRAND_NAME in the
// sidebar. Fixed per product (not per tenant) per user direction.
export const PRODUCT_SUBLABEL = 'Audit AI';

// Optional image override. When falsy (default), the sidebar renders
// the BRAND_CODE text tile per the reference design.
export const BRAND_LOGO_SRC: string =
  import.meta.env.VITE_BRAND_LOGO_SRC || '';
